var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7538 3.17383H3.49462C2.2118 3.17383 1.17188 4.21376 1.17188 5.49657V21.7558C1.17188 23.0386 2.2118 24.0785 3.49462 24.0785H19.7538C21.0366 24.0785 22.0766 23.0386 22.0766 21.7558V5.49657C22.0766 4.21376 21.0366 3.17383 19.7538 3.17383Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.2697 0.851562V5.49705M6.97873 0.851562V5.49705M1.17188 10.1425H22.0766M6.97873 14.788H6.99035M11.6242 14.788H11.6358M16.2697 14.788H16.2813M6.97873 19.4335H6.99035M11.6242 19.4335H11.6358M16.2697 19.4335H16.2813",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateImg);
export default __webpack_public_path__ + "static/media/date_img.7a41eb2942efd020ca0ba11b11c45850.svg";
export { ForwardRef as ReactComponent };